import { type FC } from 'react'

export const withDisplayName = <P extends Record<string, unknown>>(
  Component: FC<P>,
  displayName: string
): FC<P> => {
  const ComponentWithDisplayName: FC<P> = Component

  ComponentWithDisplayName.displayName = displayName

  return ComponentWithDisplayName
}
